import './updateRegistrationCardModal.scss'
import { UpdateRegistrationCardModalProps } from './types/updateRegistrationCardModalProps'
import Modal from '../../../../components/modalWindow/modal';
import { ReactComponent as addNotes } from '../../../../icons/add_notes.svg';
import ButtonField from '../../../../components/buttonField/buttonField';
import { stylizationVerticalAlign } from '../../../../components/shared/stylization';
import { iconPosition } from '../../../../components/shared/button/types/buttonProps';
import { ButtonFieldProps } from '../../../../components/buttonField/types/buttonFieldProps';
import { useState } from 'react';
import ConfirmModal from '../../../../components/modalWindow/confirmModal';
import { ObjectType } from '../../../../contexts/types/card';

const UpdateRegistrationCardModal = (props: UpdateRegistrationCardModalProps) => {
    const [buttonDisabled, setButtonDisabled] = useState(false);
    var has2020 = false;
    var has2007 = false;
    if(props.rows){
        var krChecked = props.rows.filter(item => item.original.attributes.RODZAJ_OBIEKTU === ObjectType.KRO || item.original.attributes.RODZAJ_OBIEKTU === ObjectType.KRTZ);
        krChecked.forEach(item => {
            var attrs = item.original.attributes;
            if(attrs.WZOR && attrs.WZOR === 2007){
                has2007 = true;
            }
            if(attrs.WZOR && attrs.WZOR === 2020){
                has2020 = true;
            }
        })
    }
    if(props.rowsSignle){
        var krCheckedSingle = props.rowsSignle
        krCheckedSingle.forEach(item => {
            var attrs = item;
            if(attrs.cardPattern && attrs.cardPattern === 2007){
                has2007 = true;
            }
            if(attrs.cardPattern && attrs.cardPattern === 2020){
                has2020 = true;
            }
        })
    }
    
    const getBtnProps = (title: string, onClick: React.MouseEventHandler<HTMLButtonElement>, permissionDisable: boolean): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                style: {
                    width: '146px',
                    height: '146px'
                },
                className: "cardItem body-txt-XL",
                disabled: permissionDisable ? permissionDisable : buttonDisabled
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: addNotes,
            iconPosition: iconPosition.Start,
        };
    }

    return (<>
    {has2007&& !has2020 && <Modal
            title={"Wybierz wersję karty"}
        titleIcon={addNotes}
        width={'640px'}
        height={'280px'}
        onClose={props.onClose}>
        <div className='cardBtnsUpdate'>
            <ButtonField {...getBtnProps("2007", () => { props.callback(2007); setButtonDisabled(true) }, buttonDisabled)}></ButtonField>
            <ButtonField {...getBtnProps("2020", () => { props.callback(2020); setButtonDisabled(true) }, buttonDisabled)}></ButtonField>
        </div>
    </Modal>}
    {has2020 && has2007 && <ConfirmModal width={"660px"} height={"auto"}
                confirmTitle={"Tak, chcę"}
                onConfirm={() => {props.callback(2020)}}
                cancelTitle={"Anuluj"}
                onCancel={props.onClose}
                declineTitle={"Nie, zostaw karty w wersjach dotychczasowych"}
                onDecline={() => {props.callback(undefined)}}
                question={"Wybrałeś karty o różnych wersjach, czy chcesz wszystkie zmienić na wersję 2020?"}
            />}
        </>)
}

export default UpdateRegistrationCardModal;